export default __webpack_public_path__ + "static/summer_containers27-530c18ce7d2602cc3a8c6da0d996f08d.webp";